import { render } from "./SpecialVue.vue?vue&type=template&id=22921e3f"
import script from "./SpecialVue.vue?vue&type=script&lang=js"
export * from "./SpecialVue.vue?vue&type=script&lang=js"

import "./SpecialVue.vue?vue&type=style&index=0&id=22921e3f&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__